import { Provider } from '@angular/core';
import { CommentParserV1Service } from './comment-parser/comment-parser-v1.service';
import { CounterEntryParserV1Service } from './counter-entry-parser/counter-entry-parser-v1.service';
import { CurrencyParserV1Service } from './currencies/currency-parser-v1.service';
import { DashboardParserV1Service } from './dashboard-parser/dashboard-parser-v1.service';
import { DataEntityActionParserV1Service } from './data-entity-action-parser/data-entity-action-parser-v1.service';
import { DataEntityTemplateParserV1Service } from './data-entity-template-parser/data-entity-template-parser-v1.service';
import { DataEntityTiggerParserV1Service } from './data-entity-trigger-parser/data-entity-tigger-parser-v1.service';
import { DataEntityWorkflowParserService } from './data-entity-workflow-parser/data-entity-workflow-parser.service';
import { DataEntryHistoryParserV1Service } from './data-entry-history-parser/data-entry-history-parser-v1.service';
import { DataEntryParserV1Service } from './data-entry-pareser/data-entry-parser-v1.service';
import { DataEntryTreeParserV1Service } from './data-entry-tree-parser/data-entry-tree-parser-v1.service';
import { EntryWorkFlowStatusParserV1Service } from './data-entry-workflow-status-parser/entry-workflow-status-parser-v1.service';
import { DataModuleParserV1Service } from './data-module-parser/data-module-parser-v1.service';
import { DataRelationsParserV1Service } from './data-relations-pareser/data-relations-parser-v1.service';
import { DataViewsParserV1Service } from './data-views-parser/data-views-parser-v1.service';
import { DataViewsPermissionsForEndUserParserV1Service } from './data-views-parser/data-views-permissions-for-end-user-parser-v1.service';
import { DelegationParserV1Service } from './delegation-parser/delegation-parser-v1.service';
import { EndUserDataViewsParserV1Service } from './end-user-view-parser/end-user-data-views-parser-v1.service';
import { EntityVersionChangesParserV1Service } from './enity-version-changes-parser/entity-version-changes-parser-v1.service';
import { EntityParserV1Service } from './entity-parser/entity-parser-v1.service';
import { EntryEmailsParserV1Service } from './entry-emails-parser/entry-emails-parser-v1.service';
import { FieldParserV1Service } from './field-parser/field-parser-v1.service';
import { FunctionsParserV1Service } from './functions-parser/functions-parser-v1.service';
import { GenericViewsParserV1Service } from './generic-views-parser/generic-views-parser-v1.service';
import { InternalEntityParserService } from './internal-entity-parser/internal-entity-parser.service';
import { LockObjectParserV1Service } from './lock-object-history-parser/lock-object-history-parser-v1.service';
import {
  EmailParserV1Service,
  SmsParserV1Service,
  SystemLogsParserV1Service,
} from './logs';
import { DuplicatedCollectionParserV1Service } from './lov-parser/duplicated-collection-parser-v1.service';
import { LovParserV1Service } from './lov-parser/lov-parser-v1.service';
import { SharedCollectionParserV1Service } from './lov-parser/shared-collection-parser-v1.service';
import { NavigationParserV2Service } from './navigation-parser/navigation-parser-v2.service';
import { NotificationParserV1Service } from './notification-parser/notification-parser-v1-service';
import { PermissionsParserV1Service } from './permissions-parser/permissions-parser-v1.service';
import { PublicGenericViewsParserV1Service } from './public-generic-view-parser/public-generic-view-parser.service';
import { QueryParseV1Service } from './query-parser/query-parser-v1.service';
import { ReportsParserService } from './reports-parser/reports-parser.service';
import { SpaceEntryParserV1Service } from './space-entry-parser/space-entry-parser-v1.service';
import { StatisticQueryParserService } from './statistic-query-parser/statistic-query-parser.service';
import { SystemButtonParserV1Service } from './system-button-parser/system-button-parser-v1.service';
import { TimelinePostV1ParserService } from './timeline-post-parser/timeline-post-parser-v1.service';
import { TransformationParserV1Service } from './transformation-parser/transformation-parser-v1.service';
import { UserParserV1Service } from './user-pareser/user-parser-v1.service';
import { WorkflowActionParserService } from './workflow-action-parser/workflow-action-parser.service';
import { WorkflowStepParserService } from './workflow-step-parser/workflow-step-parser.service';

export const CORE_PARSERS: Provider[] = [
  UserParserV1Service,
  PermissionsParserV1Service,
  DataEntityWorkflowParserService,
  WorkflowStepParserService,
  WorkflowActionParserService,
  DataEntityActionParserV1Service,
  LockObjectParserV1Service,
  DataEntityTiggerParserV1Service,
  FieldParserV1Service,
  InternalEntityParserService,
  EntityParserV1Service,
  DataEntryParserV1Service,
  DataViewsParserV1Service,
  DataViewsPermissionsForEndUserParserV1Service,
  DataRelationsParserV1Service,
  DataModuleParserV1Service,
  DashboardParserV1Service,
  StatisticQueryParserService,
  ReportsParserService,
  GenericViewsParserV1Service,
  LovParserV1Service,
  DuplicatedCollectionParserV1Service,
  SharedCollectionParserV1Service,
  QueryParseV1Service,
  NotificationParserV1Service,
  TimelinePostV1ParserService,
  DataEntryTreeParserV1Service,
  CommentParserV1Service,
  NavigationParserV2Service,
  EntryWorkFlowStatusParserV1Service,
  CounterEntryParserV1Service,
  SystemButtonParserV1Service,
  DataEntryHistoryParserV1Service,
  DataEntityTemplateParserV1Service,
  SpaceEntryParserV1Service,
  PublicGenericViewsParserV1Service,
  EmailParserV1Service,
  SmsParserV1Service,
  SystemLogsParserV1Service,
  CurrencyParserV1Service,
  DelegationParserV1Service,
  EntryEmailsParserV1Service,
  EndUserDataViewsParserV1Service,
  EntityVersionChangesParserV1Service,
  TransformationParserV1Service,
];

export {
  CommentParserV1Service,
  CounterEntryParserV1Service,
  CurrencyParserV1Service,
  DashboardParserV1Service,
  DataEntityActionParserV1Service,
  DataEntityTemplateParserV1Service,
  DataEntityTiggerParserV1Service,
  DataEntityWorkflowParserService,
  DataEntryHistoryParserV1Service,
  DataEntryParserV1Service,
  DataEntryTreeParserV1Service,
  DataModuleParserV1Service,
  DataRelationsParserV1Service,
  DataViewsParserV1Service,
  DataViewsPermissionsForEndUserParserV1Service,
  DelegationParserV1Service,
  DuplicatedCollectionParserV1Service,
  EmailParserV1Service,
  EndUserDataViewsParserV1Service,
  EntityParserV1Service,
  EntityVersionChangesParserV1Service,
  EntryEmailsParserV1Service,
  EntryWorkFlowStatusParserV1Service,
  FieldParserV1Service,
  FunctionsParserV1Service,
  GenericViewsParserV1Service,
  InternalEntityParserService,
  LockObjectParserV1Service,
  LovParserV1Service,
  NavigationParserV2Service,
  NotificationParserV1Service,
  PermissionsParserV1Service,
  PublicGenericViewsParserV1Service,
  QueryParseV1Service,
  ReportsParserService,
  SharedCollectionParserV1Service,
  SmsParserV1Service,
  SpaceEntryParserV1Service,
  StatisticQueryParserService,
  SystemButtonParserV1Service,
  TimelinePostV1ParserService,
  TransformationParserV1Service,
  UserParserV1Service,
  WorkflowActionParserService,
  WorkflowStepParserService,
};
